import { IS_PRERENDERING } from '@/init/settings.ts'

export function tableOfContentsHighlighting() {
  if (IS_PRERENDERING) {
    return
  }

  window.addEventListener(
    'load',
    function () {
      const sections = document.querySelectorAll(
        '.editor__title, .content-item__title',
      )
      observe(sections)
    },
    false,
  )

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => setCurrentChapter(entry))
    },
    {
      rootMargin: '0px 0px -70% 0px',
    },
  )

  function observe(sections) {
    sections.forEach((section) => {
      observer.observe(section)
    })
  }

  function setCurrentChapter(observerEntry) {
    const currentSection = observerEntry.target
    const currentSectionId = currentSection.getAttribute('id')

    if (observerEntry.intersectionRatio > 0 && currentSectionId !== null) {
      const previousHighlightedSection = document.querySelector(
        '.directory__item--active',
      )
      if (previousHighlightedSection) {
        previousHighlightedSection.classList.remove('directory__item--active')
      }

      const newHighlightedSection = document.querySelector(
        `.directory__item[href="#${currentSectionId}"]`,
      )
      if (newHighlightedSection) {
        newHighlightedSection.classList.add('directory__item--active')
      }
    }
  }
}

export function toggleTableOfContents() {
  if (IS_PRERENDERING) {
    return
  }

  window.addEventListener(
    'load',
    () => {
      const tableOfContentsButton = document.querySelector('.directory__title')

      if (!tableOfContentsButton) {
        return
      }

      tableOfContentsButton.addEventListener('click', () => {
        const tableOfContents = document.querySelector('.directory')

        if (tableOfContents.classList.contains('preload')) {
          tableOfContents.classList.remove('preload')
        }
        if (tableOfContents.classList.contains('show')) {
          tableOfContents.classList.remove('show')
        } else {
          tableOfContents.classList.add('show')
        }
      })
    },
    false,
  )
}
